import { ValiError } from 'valibot';

import { API } from '@/api';
import { fetcher, HTTPError, logger } from '@/services/fetcher';

import { type StatesParams, statesApiSchema } from '../../models';

const primaryApi = fetcher.extend(() => ({ prefixUrl: `${API.PRIMARY}` }));

export const fetchStates = async (params: StatesParams, { signal }: { signal?: AbortController['signal'] } = {}) => {
  try {
    return await primaryApi
      .get('GetStates', { searchParams: { CountryCode: params.CountryCode }, signal })
      .json(statesApiSchema);
  } catch (error) {
    if (error instanceof ValiError || (error instanceof Error && error.name === 'ValiError')) {
      logger.warn('Validation error on states response', (error as ValiError<typeof statesApiSchema>).issues);
    }
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
